// src/keycloak.js
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://keycloak-hom.fazenda.mg.gov.br/',
  realm: 'cgibs-extranet',
  clientId: 'cgibs-apuracao',
});

export default keycloak;
